var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{attrs:{"src":_vm.src || require('@/assets/images/no-image.png'),"alt":_vm.alt,"src-placeholder":require('@/assets/images/unnamed.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }